import Vue from 'vue';

const Files = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        fetchFromS3: ({state, dispatch, commit}, payload) => {
            return Vue.prototype.$S3Service
                .get(payload.url, payload.config)
                .then(response => {
                    return response.data;
                })
                .catch(err => {
                    console.log(err.response);
                    return err;
                });
        },

        downloadLuts: ({rootState}, payload) => {
            let formData = new FormData();

            if (payload.cube_pixels && payload.cube_meta) {
                formData.append("cube_pixels", payload.cube_pixels);
                formData.append('cube_meta', payload.cube_meta);
            }

            return Vue.prototype.$apiService
                .post(`download-luts`, formData)
                .catch(() => null)
        },

        downloadFreeLutsPackage: ({ rootState }) => {
            return Vue.prototype.$apiService
              .get(`accounts/${rootState.User.account.id}/download-free-luts-package`)
              .then(({ data }) => {
                return data
              })
              .catch(() => null)
        }
    },
    getters: {}
};

export default Files;
